function initAjaxTable() {
  if ($('#table-compare-body').length == 0) {
    return false;
  }

  const table = $('#table-compare');
  const tableBody = $('#table-compare-body');

  getPosts();

  function getPosts() {
    const posts = getPostsToCompare();
    if (!posts.length) {
      $('.table-compare-module-alert-text').html(fpm001_localize.table_compare_no_posts);
      return;
    }

    let data = {
      action: 'get_table_posts',
      nonce: fpm001_localize.nonce,
      taxonomies: fpm001_table_taxonomies.taxonomies,
      posts: posts,
    };

    $.post(fpm001_localize.ajax_url, data, function (response) {
      if (response.data) {
        table.addClass('active');
        tableBody.html(response.data.html_posts);
      }
    });
  }

  function getPostsToCompare() {
    const data = sessionStorage.getItem('compare');
    return data === null ? [] : JSON.parse(data);
  }
}

export { initAjaxTable }



// WEBPACK FOOTER //
// ./scripts/modules/ajax-table.js